import React from 'react'
import styled from 'styled-components'
import { Header, HeaderSize } from 'components/styled/header'
import { HeaderActions } from 'components/page-header/page-header-actions'

export interface PageHeaderProps {
  photo?:
    | string
    | {
        file: string
      }
  contentLeft?: React.ReactNode
  contentRight?: React.ReactNode
  actionsLeft?: React.ReactNode[]
  actionsRight?: React.ReactNode[]
  photoModel?: string
  size?: HeaderSize
  children?: React.ReactNode | React.ReactNode[]
  className?: string
}

const HeaderContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
`

const ContentWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: space-between;
  bottom: 0;
  width: 100%;
  align-items: flex-end;
  padding: ${({ theme }) => theme.space.s12};
  color: ${({ theme }) => theme.color.white};

  ${({ theme }) => theme.mediaQuery.tablet} {
    position: relative;
    padding: 0;
  }
`

const RightContentWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`
const LeftContentWrapper = styled.div`
  display: flex;
  justify-content: flext-start;
`

export const PageHeader = ({
  photo,
  contentLeft,
  contentRight,
  actionsLeft,
  actionsRight,
  photoModel,
  className,
  size = 'medium',
  children,
  ...props
}: PageHeaderProps) => (
  <HeaderContainer className={`admin-cover-photo ${className}`}>
    <Header
      useTallOnMobile={!!(contentLeft && contentRight)}
      image={photo}
      {...props}
      size={size}
    >
      {children}
      {(contentLeft || contentRight) && (
        <ContentWrapper>
          <LeftContentWrapper>{contentLeft}</LeftContentWrapper>
          <RightContentWrapper>{contentRight}</RightContentWrapper>
        </ContentWrapper>
      )}
    </Header>
    {(actionsRight || actionsLeft || photoModel) && (
      <HeaderActions
        actionsLeft={actionsLeft}
        actionsRight={actionsRight}
        photoModel={photoModel}
        hasDefault={!photo}
      />
    )}
  </HeaderContainer>
)
